<template>
    <div id="save-all-as-candidates-processing-modal" class="modal-new hidden">
        <span class="title">Save as Candidate</span>

        <div class="d-flex flex-column align-center">
			<span class="label-container mb-5">
				<span>Processing file {{ fileName }}</span>
			</span>
            <v-progress-circular color="var(--primary)" indeterminate size="36" width="3" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('Projects', {
            fileName: 'saveAllAsCandidatesProcessingFile'
        })
    },

    methods: {
        onCancel() {
            window.UI.hideModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.label-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  span {
	line-height: 1.2;
  }
}
</style>